import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import Hoot from "../../Hoot";
import ClickAllRefreshButtons from "../../ClickAllRefreshButtons";
import Avatar from "@mui/material/Avatar";
import { toast } from "react-hot-toast";
import getLogo from "../../getLogo";

const ServiceTable = [
  { title: "Demonstração", price: 0, type: 0, coin: "AOA" },
  { title: "Plano básico", price: 149999, type: 0, coin: "AOA" },
  { title: "Plano premium", price: 229999, type: 0, coin: "AOA" },
  { title: "Plano avançado", price: 349999, type: 0, coin: "AOA" },
  { title: "Plano platina (universidades)", price: 579999, type: 1, coin: "AOA" },
  { title: "Plano diamante (universidade)", price: 859999, type: 1, coin: "AOA" },
];

const PaymentOptions = [
  { id: 0, label: "Mensal (1 mês)", months: 1 },
  { id: 1, label: "Trimestral (3 meses)", months: 3 },
  { id: 2, label: "Semestral (6 meses)", months: 6 },
  { id: 3, label: "Anual (12 meses)", months: 12 },
];

const DiscountTable = [
  { type: 1, discount: 3 },
  { type: 2, discount: 6 },
  { type: 3, discount: 10 },
];

function safeNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function formatAOA(n) {
  return safeNum(n).toLocaleString("pt-PT");
}

const styles = `
.pretty-modal .modal-dialog{
  max-width: 760px;
}
@media (max-width: 768px){
  .pretty-modal .modal-dialog{ max-width: 96vw; }
}
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-title{
  font-weight: 650;
  color: #0f172a;
  font-size: 1rem;
}

.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}
.body-scroll{
  max-height: 520px;
  overflow-y: auto;
  padding-right: 4px;
}

.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}

.header-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
}
.header-left{
  display:flex;
  align-items:center;
  gap:12px;
}
.avatar-wrap{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(91,92,255,.10);
  border: 1px solid rgba(91,92,255,.18);
  display:grid;
  place-items:center;
}
.title-sub{
  margin-top:2px;
  font-size: .8rem;
  color: #64748b;
  font-weight: 500;
}

.form-grid{
  display:grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}
@media (max-width: 720px){
  .form-grid{ grid-template-columns: 1fr; }
}
.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem;
  color:#64748b;
  font-weight: 600;
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom: 8px;
}
.req{
  color:#ef4444;
  font-weight:700;
}

.form-label{
  font-size: .78rem !important;
  color: #475569 !important;
  font-weight: 600 !important;
  margin-bottom: 6px !important;
}
.form-control, .form-select{
  border-radius: 12px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}
.helper{
  font-size: .74rem;
  color:#64748b;
  margin-top: 6px;
}

.institute-banner{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
  border-radius: 16px;
  border: 1px solid rgba(91,92,255,.18);
  background:
    radial-gradient(900px 220px at 20% 0%, rgba(91,92,255,.10), transparent 60%),
    rgba(255,255,255,.9);
  padding: 10px 12px;
}
.banner-left{
  display:flex;
  align-items:center;
  gap:12px;
  min-width: 240px;
}
.logo-sq{
  width: 56px;
  height: 56px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(226,232,240,.95);
  background: rgba(248,250,252,.85);
  display:grid;
  place-items:center;
}
.logo-sq img{
  width:100%;
  height:100%;
  object-fit:cover;
}
.banner-name{
  font-weight: 700;
  color:#0f172a;
  line-height:1.1;
}
.banner-sub{
  margin-top: 4px;
  color:#64748b;
  font-size: .78rem;
  display:flex;
  gap:10px;
  flex-wrap:wrap;
}
.pill{
  display:inline-flex;
  align-items:center;
  gap:6px;
  border-radius: 999px;
  padding: 2px 10px;
  border: 1px solid rgba(226,232,240,.95);
  background: rgba(248,250,252,.9);
  font-size: .74rem;
  color:#475569;
  font-weight: 600;
}

.price-box{
  min-width: 220px;
  border-radius: 16px;
  border: 1px solid rgba(226,232,240,.95);
  background: rgba(248,250,252,.75);
  padding: 10px 12px;
}
.price-title{
  font-size:.78rem;
  color:#64748b;
  font-weight: 700;
}
.price-value{
  margin-top: 2px;
  font-weight: 800;
  font-size: 1.05rem;
  color:#0f172a;
}
.price-line{
  margin-top: 6px;
  font-size:.78rem;
  color:#64748b;
}
.price-line strong{ color:#0f172a; }

.actions{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  flex-wrap:wrap;
}
.btn-soft{
  border-radius: 999px !important;
  border: 1px solid rgba(226,232,240,.95) !important;
  background: #fff !important;
}
.btn-primary{
  border-radius: 999px !important;
}

/* react-select align */
.rs__control{
  border-radius: 12px !important;
  border-color: rgba(226,232,240,.95) !important;
  min-height: 44px !important;
  box-shadow:none !important;
}
.rs__control--is-focused{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}
.rs__menu{
  border-radius: 14px !important;
  overflow:hidden;
  border: 1px solid rgba(226,232,240,.95) !important;
}
`;

export default function RegisterAndUpdateLicenceModal({
  update = false,
  update_url,
  get_data_url,
  toggle_btn,
  code,
}) {
  const [show, setShow] = useState(false);
  const [institutions, setInstitutions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    institution_code: code || "",
    service_index: "",
    payment_type: "",
    selectedInstitution: null,
  });

  const [totalPrice, setTotalPrice] = useState(null);
  const [discountMessage, setDiscountMessage] = useState(null);
  const [basePrice, setBasePrice] = useState(0);
  const [finalDiscountValue, setFinalDiscountValue] = useState(0);

  const openModal = () => setShow(true);

  const closeModal = () => {
    if (loading) return;
    setShow(false);
    setLoading(false);
    setError(null);
    setTotalPrice(null);
    setDiscountMessage(null);
    setBasePrice(0);
    setFinalDiscountValue(0);

    setFormData({
      institution_code: code || "",
      service_index: "",
      payment_type: "",
      selectedInstitution: code ? formData.selectedInstitution : null,
    });
  };

  async function loadData() {
    try {
      setError(null);
      const res = await axios.get(Hoot() + "institutes", { withCredentials: true });
      const list = res.data || [];
      setInstitutions(list);

      if (code) {
        const selected = list.find((inst) => inst.code === code);
        if (selected) {
          setFormData((prev) => ({
            ...prev,
            institution_code: selected.code,
            selectedInstitution: selected,
          }));
        } else {
          setError("Instituição com este código não foi encontrada.");
        }
      }
    } catch (err) {
      setError("Erro ao carregar instituições.");
    }
  }

  useEffect(() => {
    if (show) loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  // Calcula preço/discount sempre que seleções mudam
  useEffect(() => {
    const service = ServiceTable[formData.service_index];
    const payment = PaymentOptions.find((p) => p.id === formData.payment_type);
    const role = formData.selectedInstitution?.ed_institute_specificrole || "normal";
    const studentCount = safeNum(formData.selectedInstitution?.studentcount);

    setDiscountMessage(null);

    if (service && payment) {
      // Demonstração = sempre 0
      if (service.title === "Demonstração") {
        setBasePrice(0);
        setFinalDiscountValue(0);
        setTotalPrice(0);
        return;
      }

      let base = service.price;
      let total = base * payment.months;
      let discountValue = 0;

      // regras específicas
      if (role === "ensinobasico" && service.title === "Plano premium" && studentCount <= 1500) {
        base = ServiceTable.find((s) => s.title === "Plano básico")?.price ?? base;
        total = base * payment.months;
        setDiscountMessage(
          "Desconto aplicado: Plano Premium com valor de Plano Básico para escolas do ensino básico com até 1500 estudantes."
        );
      }

      if (role === "ensinomedio" && service.title === "Plano avançado" && studentCount <= 1500) {
        base = ServiceTable.find((s) => s.title === "Plano premium")?.price ?? base;
        total = base * payment.months;
        setDiscountMessage(
          "Desconto aplicado: Plano Avançado com valor de Plano Premium para escolas do ensino médio com até 1500 estudantes."
        );
      }

      // desconto por periodicidade
      const discountData = DiscountTable.find((d) => d.type === payment.id);
      if (discountData) {
        discountValue = (total * discountData.discount) / 100;
        total -= discountValue;
      }

      setBasePrice(base * payment.months);
      setFinalDiscountValue(discountValue);
      setTotalPrice(total);
    } else {
      setTotalPrice(null);
      setBasePrice(0);
      setFinalDiscountValue(0);
    }
  }, [formData.service_index, formData.payment_type, formData.selectedInstitution]);

  const selectedService = ServiceTable[formData.service_index];
  const allowedPaymentOptions = selectedService
    ? selectedService.title === "Demonstração"
      ? [{ id: 0, label: "Mensal (1 mês)", months: 1 }]
      : PaymentOptions
    : [];

  const institutionOptions = useMemo(() => {
    return (institutions || []).map((inst) => ({
      value: inst.code,
      label: (
        <div className="d-flex align-items-center gap-2">
          <Avatar
            variant="rounded"
            src={getLogo(inst)}
            alt={inst.name}
            sx={{ width: 44, height: 44, borderRadius: 3 }}
          />
          <div className="d-block">
            <div style={{ fontWeight: 650 }}>{inst.name}</div>
            <div>
              <small className="text-danger">NIF: {inst.nif}</small>
            </div>
          </div>
        </div>
      ),
      data: inst,
    }));
  }, [institutions]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (formData.service_index === "" || !formData.institution_code || formData.payment_type === "") {
      toast.error("Preencha todos os campos!");
      return;
    }

    const service = ServiceTable[formData.service_index];
    const payment = PaymentOptions.find((p) => p.id === formData.payment_type);

    const role = formData.selectedInstitution?.ed_institute_specificrole || "normal";
    const studentCount = safeNum(formData.selectedInstitution?.studentcount);

    // regras de permissões por role
    if (role === "ensinobasico" && !["Plano premium", "Demonstração"].includes(service.title)) {
      toast.error('Instituições do ensino básico só podem contratar Plano premium ou Demonstração.');
      return;
    }

    if (role === "ensinomedio" && !["Plano avançado", "Demonstração"].includes(service.title)) {
      toast.error('Instituições do ensino médio só podem contratar Plano avançado ou Demonstração.');
      return;
    }

    if (
      (role === "ensinobasico" && service.title === "Plano premium" && studentCount > 1500) ||
      (role === "ensinomedio" && service.title === "Plano avançado" && studentCount > 1500)
    ) {
      toast.error("A escola excede o limite de 1500 estudantes para o desconto automático.");
      return;
    }

    if (service.title === "Demonstração" && payment?.months !== 1) {
      toast.error('O serviço "Demonstração" só permite pagamento mensal.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const payload = {
        institution_code: formData.institution_code,
        licence_service: formData.service_index,
        licence_type: formData.payment_type,
        total_price: totalPrice,
      };

      await axios.post(
        Hoot() + "register-and-update-licence/" + formData.institution_code,
        payload,
        { withCredentials: true }
      );

      toast.success(update ? "Licença atualizada com sucesso!" : "Licença registada com sucesso!");
      closeModal();
      ClickAllRefreshButtons();
    } catch (err) {
      console.clear();
      console.log(err?.response);
      setError(err?.response?.data?.msg || "Erro ao registar licença.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const selectedInstitute = formData.selectedInstitution;

  return (
    <>
      <style>{styles}</style>

      <div onClick={openModal} style={{ display: "inline-block" }}>
        {toggle_btn}
      </div>

      <Modal
        show={show}
        onHide={closeModal}
        centered
        backdrop="static"
        keyboard={!loading}
        className="pretty-modal"
      >
        <Modal.Header closeButton={!loading}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="avatar-wrap">
                <i className="bi bi-shield-lock" style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>

              <div>
                <div style={{ fontWeight: 650 }}>
                  {update ? "Atualizar licença" : "Pagar licença"}
                </div>
                <div className="title-sub">
                  Selecione a instituição, o plano e o tipo de pagamento.
                </div>
              </div>
            </div>

            {selectedInstitute ? (
              <Avatar
                src={getLogo(selectedInstitute)}
                alt="Instituição"
                sx={{ width: 44, height: 44, borderRadius: 3 }}
              />
            ) : null}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error && (
              <Alert variant="danger" className="mb-3" style={{ borderRadius: 14 }}>
                {error}
              </Alert>
            )}

            <Form id="licence-form" onSubmit={handleSubmit}>
              <div className="form-grid">
                {/* Instituição */}
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-building" />
                    Instituição
                  </div>

                  {!code ? (
                    <Form.Group>
                      <Form.Label>
                        Selecionar instituição <span className="req">*</span>
                      </Form.Label>
                      <Select
                        classNamePrefix="rs"
                        options={institutionOptions}
                        placeholder="Pesquisar instituição..."
                        onChange={(option) => {
                          setFormData((prev) => ({
                            ...prev,
                            institution_code: option.value,
                            selectedInstitution: option.data,
                          }));
                        }}
                      />
                      <div className="helper">Pesquise pelo nome e selecione a instituição.</div>
                    </Form.Group>
                  ) : (
                    <div className="helper">Instituição pré-selecionada (via código).</div>
                  )}

                  {selectedInstitute ? (
                    <div className="mt-3 institute-banner">
                      <div className="banner-left">
                        <div className="logo-sq">
                          <img
                            src={getLogo(selectedInstitute)}
                            alt={selectedInstitute?.name || "School logo"}
                            onError={(e) => {
                              e.currentTarget.src =
                                "https://shop.raceya.fit/wp-content/uploads/2020/11/logo-placeholder.jpg";
                            }}
                          />
                        </div>

                        <div>
                          <div className="banner-name">{selectedInstitute.name}</div>
                          <div className="banner-sub">
                            <span className="pill">NIF: {selectedInstitute.nif || "—"}</span>
                            <span className="pill">Código: {selectedInstitute.code || "—"}</span>
                            {selectedInstitute.studentcount ? (
                              <span className="pill">
                                Estudantes: {formatAOA(selectedInstitute.studentcount)}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="price-box">
                        <div className="price-title">Resumo</div>
                        <div className="price-line">
                          <strong>Plano:</strong>{" "}
                          {selectedService ? selectedService.title : "—"}
                        </div>
                        <div className="price-line">
                          <strong>Pagamento:</strong>{" "}
                          {formData.payment_type !== ""
                            ? PaymentOptions.find((p) => p.id === formData.payment_type)?.label || "—"
                            : "—"}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>

                {/* Plano */}
                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-box-seam" />
                    Plano / Serviço
                  </div>

                  <Form.Group>
                    <Form.Label>
                      Serviço <span className="req">*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      value={formData.service_index}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          service_index: e.target.value === "" ? "" : parseInt(e.target.value, 10),
                          payment_type: "",
                        }))
                      }
                    >
                      <option value="">-- Selecionar --</option>
                      {ServiceTable.map((service, idx) => (
                        <option key={idx} value={idx}>
                          {service.title} — {formatAOA(service.price)} {service.coin}
                        </option>
                      ))}
                    </Form.Select>
                    <div className="helper">Escolha o plano que pretende ativar.</div>
                  </Form.Group>
                </div>

                {/* Pagamento */}
                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-credit-card" />
                    Pagamento
                  </div>

                  <Form.Group>
                    <Form.Label>
                      Tipo de pagamento <span className="req">*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      value={formData.payment_type}
                      disabled={formData.service_index === ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          payment_type: e.target.value === "" ? "" : parseInt(e.target.value, 10),
                        }))
                      }
                    >
                      <option value="">-- Selecionar --</option>
                      {allowedPaymentOptions.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.label}
                        </option>
                      ))}
                    </Form.Select>
                    <div className="helper">Periodicidade do pagamento da licença.</div>
                  </Form.Group>
                </div>

                {/* Total */}
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-receipt" />
                    Total e descontos
                  </div>

                  {totalPrice !== null && selectedService ? (
                    <>
                      <div className="price-title">Total a pagar</div>
                      <div className="price-value">{formatAOA(totalPrice)} AOA</div>

                      <div className="price-line">
                        <strong>Base:</strong> {formatAOA(basePrice)} AOA
                      </div>

                      {finalDiscountValue > 0 ? (
                        <div className="price-line">
                          <strong>Desconto:</strong> -{formatAOA(finalDiscountValue)} AOA
                        </div>
                      ) : null}

                      {discountMessage ? (
                        <Alert
                          variant="info"
                          className="mt-2 mb-0"
                          style={{ borderRadius: 14 }}
                        >
                          {discountMessage}
                        </Alert>
                      ) : null}

                      {selectedService.title === "Demonstração" ? (
                        <div className="helper">Demonstração é gratuita e válida apenas para 1 mês.</div>
                      ) : null}
                    </>
                  ) : (
                    <div className="helper">
                      Selecione a instituição, o plano e o tipo de pagamento para ver o total.
                    </div>
                  )}
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button
              type="button"
              variant="outline-secondary"
              className="btn-soft"
              onClick={closeModal}
              disabled={loading}
            >
              Cancelar
            </Button>

            <Button type="submit" variant="primary" form="licence-form" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A guardar...
                </>
              ) : update ? (
                "Atualizar"
              ) : (
                "Confirmar"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
